import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import AdminPage from '@/pages/AdminPage';
import CareersPage from '@/pages/CareersPage';
import StudioSite from '@/studio/StudioSite';

function App() {
  return <div className="App relative bg-cream text-ink">
    <Toaster position="bottom-right" theme="dark" richColors />
    <BrowserRouter><Routes>
      <Route path="/" element={<StudioSite />} />
      <Route path="/about" element={<StudioSite page="about" />} />
      <Route path="/services/:slug" element={<StudioSite page="service" />} />
      <Route path="/work/:slug" element={<StudioSite page="project" />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<StudioSite page="not-found" />} />
    </Routes></BrowserRouter>
  </div>;
}
export default App;
